import { createResourceModule } from '../../../lib/resource/module.js';
import { inclusionDetail } from './schemas.js';

export const inclusions = createResourceModule({
  resource: 'inclusions',
  basePath: '/v1/inclusions',
  detail: inclusionDetail,
});

export const inclusionEndpoints = inclusions.endpoints;
